export default {
  crashCourseList: [],
  crashCourseSubjectList: []
}
